<template>
  <b-button v-b-modal="'modalId'+ _uid" variant="outline-primary" size="sm" v-b-tooltip.hover.topright :title="qrToolTip">
    <b-icon icon="upc-scan"/>
    <b-modal :id="'modalId'+ _uid" :title="modalTitle" ok-only class="mx-auto" header-text-variant="dark">
      <div class="d-block text-center">
        <qrcode-vue class="mx-auto" :value="qrCodeValue" size="200" level="H" />
      </div>
    </b-modal>
  </b-button>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'wifiQRCodeViewer',
  props: {
    secret: { type: String },
    secretType: {type: String},
    showChange: {type: Boolean,  default: false},
    small: {type: Boolean, default: false}
  },
  components:{
    QrcodeVue
  },
  computed:{
    qrToolTip(){
      if(this.secretType === 'IDENTITY') {
        return this.$t('unitSecret.IDENTITY_ViewQrTT')
      } else if(this.secretType === "UNIT"){
        return this.$t('unitSecret.TENANT_ViewQrTT')
      }
      return this.$t('unitSecret.GUEST_ViewQrTT')
    },
    modalTitle() {
      if(this.secretType === 'IDENTITY') {
        return this.$t('qrCodeModal.IDENTITY_Title')
      } else if(this.secretType === 'UNIT') {
        return this.$t('qrCodeModal.TENANT_Title')
      }
      return this.$t('qrCodeModal.GUEST_Title')
    },
    qrCodeValue(){
      if(this.secretType === "IDENTITY") {
        return 'WIFI:T:WPA;S:' + this.$store.getters.getPropertySingleSSID + ';P:' + this.$store.getters.getSelectedUserPassphrase + ';;'
      } else if(this.secretType === "UNIT") {
        return 'WIFI:T:WPA;S:' + this.$store.getters.getPropertySingleSSID + ';P:' + this.$store.getters.getUnitSecret + ';;'
      }
      return 'WIFI:T:WPA;S:' + this.$store.getters.getPropertySingleSSID + ';P:' + this.$store.getters.getUnitGuestSecret + ';;'
    },
  }
}
</script>

<style>
#qrSsidSecretModalUnit___BV_modal_outer_{
  z-index: 1999 !important;
}
#qrSsidSecretModalGuest___BV_modal_outer_{
  z-index: 1999 !important;
}
</style>